module.exports = __webpack_public_path__ + "img/partners15.09033106.png";